import { ClockIcon, HashtagIcon, LightningBoltIcon, TagIcon, ViewGridIcon } from "@heroicons/react/outline";
import { PencilIcon } from "@heroicons/react/solid";
import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import Button from "components/button";
import { DescriptionItem } from "components/descriptionItem";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLodModal } from "components/historyLogModal";
import { ISupportCategoryItem } from "interfaces";
import { useState } from "react";
import { Link } from "react-router-dom";
import { isHaveActionPermission } from "utills/helpers";

export const SupportCategoyDetail: React.FC = () => {
  const [openLogModal, setOpenLogModal] = useState(false);

  const parse = useParse();
  const { params } = parse();
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<ISupportCategoryItem>({
    resource: "cs/support-center/categories",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const supportCategoryDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="w-full flex flex-col items-center gap-y-3 sm:gap-y-4">
      <Breadcrumbs
        customPageLabel="Support Center Category Detail"
        additionalLabel={
          <div className="flex gap-x-2">
            <Button
              className="bg-white border-brand-500 border-[1px] border-solid text-brand-500 hover:bg-white active:bg-slate-200"
              onClick={() => setOpenLogModal(true)}
            >
              <span className="sr-only">History Log</span>
              <ClockIcon className="w-4 h-4 text-brand-500" />{" "}
              <span className="hidden sm:block sm:ml-2">Log</span>
            </Button>
            {isHaveActionPermission("support_categories", "cs", "edit") ? (
              <Link
                to={`/cs/support-category/${supportCategoryDetailData?.id}/edit`}
              >
                <Button>
                  <span className="sr-only">Edit</span>
                  <PencilIcon className="w-4 h-4 text-white" />{" "}
                  <span className="hidden sm:block sm:ml-2">Edit</span>
                </Button>
              </Link>
            ) : (
              <></>
            )}
          </div>
        }
      />

      <div className="box-container p-0">
        <div className="divide-y divide-gray-100">
          <DescriptionItem
            icon={TagIcon}
            label="Status"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {supportCategoryDetailData?.is_active ? "Active" : "Inactive"}
              </p>
            }
          />
          <DescriptionItem
            icon={ViewGridIcon}
            label="Categories name vie"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {supportCategoryDetailData?.name_vi}
              </p>
            }
          />
          <DescriptionItem
            icon={ViewGridIcon}
            label="Categories name eng"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {supportCategoryDetailData?.name_en}
              </p>
            }
          />
          <DescriptionItem
            icon={HashtagIcon}
            label="Position"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {supportCategoryDetailData?.order_number}
              </p>
            }
          />
          <DescriptionItem
            icon={LightningBoltIcon}
            label="Number of Q&A"
            content={
              <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                {supportCategoryDetailData?.number_of_qa}
              </p>
            }
          />
        </div>
      </div>
      <HistoryLodModal
        resource={`cs/support-center/categories/${params?.id}/history`}
        open={openLogModal}
        onClose={() => setOpenLogModal(false)}
        key="support-category"
        id="support-category"
      />
      
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}